module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"headline":"Kodėl verta?","head":"Lietuvoje jau daugiau nei 700 vartotojų džiaugiasi mūsų pastatyta saulės elektrine.\\n\\n**Prisijunkite ir Jūs!**","side":"- atsiperka per 5-7 metus\\n- 80% mažesnės sąskaitos už elektrą\\n- galimybė gauti paramą;\\n- elektrinę įsigyti galite išsimokėtinai"}}')
  delete Component.options._Ctor
}
